import { Injectable } from '@angular/core';
import { DataService } from '../network/data.service';
import { ProjectService } from '../project/project.service';

import { ImportStep } from './import-step';

@Injectable()
export class ImportProgressService {
    private importStep: ImportStep;
    
    constructor(private dataService: DataService, private projectService: ProjectService) {
    }

    public async getImportStep(): Promise<ImportStep> {
        if (this.importStep != undefined) {
            return this.importStep;
        }
        let projectId = this.projectService.getProjectId();
        return await this.dataService.get<ImportStep>('import/progress/' + projectId);
    }

    public clearImportStep() {
        this.importStep = undefined;
    }

    public setStartingImportStep() {
        this.importStep = ImportStep.upload;
    }

    public setImportStep(step: ImportStep) {
        this.importStep = step;
    }

    public increaseImportStep(step: ImportStep) {
        if (step > this.importStep) {
            this.importStep = step;
        }
    }
}